import styled, { css } from 'styled-components';
import { colors } from '@alixpartners/ui-components';

import { MIN_WIDTH } from 'utils/constants';

export const ChartContainer = styled.div<{ width: string }>`
  width: ${(props) => props.width};
  position: relative;

  .line-chart {
    .highcharts-markers path {
      fill: ${colors.white};
    }
  }
`;

export const LegendContainer = styled.div<{ isHidden?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 12px;
  visibility: ${(props) => (props.isHidden ? 'hidden' : 'visible')};
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  margin-left: 24px;
`;

export const LegendColor = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 1px;
  background-color: ${(props) => props.color};
`;

export const LegendName = styled.div`
  font-size: 11px;
  color: ${colors.grey8};
  margin-left: 8px;
`;

export const LegendTitle = styled.div`
  line-height: 24px;
  font-size: 16px;
`;

export const SelectedBackgroundContainer = styled.div<{ width?: number }>`
  position: relative;
`;

export const SelectedBackground = styled.div`
  position: absolute;
  background: #444444; // #F7F7F7 to be the same as the background
  opacity: 0.05;
  z-index: 1;
`;

export const TooltipContainer = styled.ul`
  display: flex;
  flex-direction: column;
  padding: 8px 12px;
  margin: 0;
`;

export const TooltipColor = styled.span<{ color: any }>`
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 8px;
  background-color: ${(props) => props.color || 'transparent'};
`;

export const TooltipItem = styled.li`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TooltipItemName = styled.span<{ isHighlighted?: boolean }>`
  font-size: 11px;
  text-transform: capitalize;
  ${({ isHighlighted }) =>
    isHighlighted &&
    css`
      font-weight: bold;
    `};
`;

export const TooltipItemValue = styled.strong`
  font-size: 11px;
  margin-left: 12px;
`;

export const TooltipItemTitle = styled.strong`
  font-size: 13px;
  margin-bottom: 8px;
`;

export const SecondaryContent = styled.div`
  height: 100%;
  min-width: ${MIN_WIDTH};
  background-color: ${colors.greyBg};
  padding: 32px;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: ${MIN_WIDTH};
  height: auto;
  padding: 24px 32px;
  background-color: ${colors.white};
  margin-bottom: 32px;
`;

export const PieChartsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 32px;
`;

export const PieChartSection = styled.div`
  display: flex;
  width: 550px;
  height: 567px;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
  background-color: ${colors.white};
  &:first-child {
    margin-right: 32px;
  }
`;
